import { Injectable, HostListener } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectionService {
  isMobile!: boolean;
  isTablet!: boolean;
  isDesktop!: boolean;

  constructor() {
    this.detectDevice();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.detectDevice();
  }

  private detectDevice() {

    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

    // Reset all flags
    this.isMobile = false;
    this.isTablet = false;
    this.isDesktop = false;

    // iPad detection (iPadOS 13+ reports as Mac)
    const isIpad = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // Android Tablet detection
    const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);

    // Generic tablet keyword
    const isGenericTablet = /Tablet/.test(ua);

    const isTablet = isIpad || isAndroidTablet || isGenericTablet;

    if (isTablet) {
      this.isTablet = true;
      console.log('Device: Tablet', { isIpad, isAndroidTablet, isGenericTablet });
      return;
    }

    // Mobile detection
    if (/iPhone|Android.*Mobile|Windows Phone/i.test(ua)) {
      this.isMobile = true;
      console.log('Device: Mobile');
      return;
    }

    // Default → Desktop
    this.isDesktop = true;
    console.log('Device: Desktop');
  }
}